import { useNavigate } from "react-router-dom";
import { Fuel, Settings2, Gauge, Calendar, Car as CarIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { euroRound } from "@/lib/api";

export const formatKm = (n) =>
  n || n === 0 ? `${new Intl.NumberFormat("it-IT").format(n)} km` : "—";

export const SaleCarCard = ({ car, index = 0 }) => {
  const navigate = useNavigate();
  const cover = car.images?.[0];
  return (
    <div
      className="group rounded-2xl overflow-hidden bg-[#181A22] border border-white/10 hover:border-[#E63946]/50 transition-all duration-300 fade-up cursor-pointer"
      style={{ animationDelay: `${index * 60}ms` }}
      onClick={() => navigate(`/vendita/${car.id}`)}
      data-testid={`sale-car-card-${car.id}`}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-black">
        {cover ? (
          <img src={cover} alt={`${car.brand} ${car.model}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/20"><CarIcon className="w-16 h-16" /></div>
        )}
        {car.condition && <Badge className="absolute top-3 left-3 bg-black/70 text-white border-0 font-mono-tech text-[10px] tracking-wider">{car.condition}</Badge>}
        {car.sold && <div className="absolute inset-0 bg-black/60 flex items-center justify-center"><span className="font-display font-extrabold text-2xl text-[#E63946] uppercase tracking-widest -rotate-6 border-4 border-[#E63946] px-4 py-1 rounded">Venduta</span></div>}
      </div>
      <div className="p-6">
        <h3 className="font-display font-bold text-xl tracking-tight">{car.brand} {car.model}</h3>
        <div className="flex flex-wrap gap-4 mt-4 text-xs text-muted-foreground">
          {car.year ? <span className="flex items-center gap-1.5"><Calendar className="w-4 h-4 amber" />{car.year}</span> : null}
          <span className="flex items-center gap-1.5"><Gauge className="w-4 h-4 amber" />{formatKm(car.mileage)}</span>
          {car.fuel ? <span className="flex items-center gap-1.5"><Fuel className="w-4 h-4 amber" />{car.fuel}</span> : null}
          {car.transmission ? <span className="flex items-center gap-1.5"><Settings2 className="w-4 h-4 amber" />{car.transmission}</span> : null}
        </div>
        <div className="flex items-end justify-between mt-6 pt-5 border-t border-white/10">
          <div>
            {car.price_on_request || !car.price ? (
              <div className="font-display font-extrabold text-lg text-[#FF9E00]">Trattativa riservata</div>
            ) : (
              <>
                <div className="font-display font-extrabold text-2xl">{euroRound(car.price)}</div>
                <div className="text-[11px] text-muted-foreground font-mono-tech tracking-wider">PREZZO</div>
              </>
            )}
          </div>
          <span className="text-sm font-semibold text-[#E63946] group-hover:translate-x-1 transition-transform">Dettagli →</span>
        </div>
      </div>
    </div>
  );
};
